import React, { PropsWithChildren, ReactNode } from "react";

interface FormSectionProps {
  title?: ReactNode;
  dataQa?: string;
}

export default function FormSection({
  title,
  children,
  dataQa,
}: PropsWithChildren<FormSectionProps>) {
  return (
    <div className="create-new-project-pane__field" data-qa={dataQa}>
      {title && <h4 className="text-h4-regular">{title}</h4>}
      {children}
    </div>
  );
}
